require('./jv.tracking.jobBoards.paramsFAC');
require('./jv.tracking.jobBoards.service');
require('./jv.tracking.jobBoards.commonActionsFAC');
require('./jv.tracking.jobBoards.listCtrl');
require('./jv.tracking.jobBoards.addCtrl');
require('./jv.tracking.jobBoards.editCtrl');

angular.module('jv.tracking.jobBoards.app', [
        'ngRoute',
        'ui',
        'jv.tracking.jobBoards.paramsFAC',
        'jv.tracking.jobBoards.service',
        'jv.tracking.jobBoards.commonActionsFAC',
        'jv.tracking.jobBoards.listCtrl',
        'jv.tracking.jobBoards.addCtrl',
        'jv.tracking.jobBoards.editCtrl'
    ])
    .value('jvTrackingMessages', {
        'UPDATED': 'Job Board has been updated.',
        'DELETED': 'Job board has been deleted.',
        'ADDED': 'Job board has been added.',
        'CONFIRM': 'are you sure, you want to delete this Job Board?',
        'OPSERROR': 'Problem while performing the operation. Please try again!'
    })
    .config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {
        $routeProvider.when('/list/:message?/:error?', {
            templateUrl: 'tracking/jobBoardList.html',
            controller: 'jobBoardsListCtrl',
            resolve: {
                jobBoards: function($q, jobBoardService){
                    var deferred = $q.defer();
                    jobBoardService.getAllJobBoards(function(jobBoards){
                        deferred.resolve(jobBoards.resultList);
                    });
                    return deferred.promise;
                }
            }
        });

        $routeProvider.when('/:jbName/edit', {
            templateUrl: 'tracking/addEditJobBoardForm.html',
            controller: 'jobBoardEditCtrl',
            resolve: {
                jobBoardDetails: function($q, $route, jobBoardService, jobBoardDataSerializeFAC){
                    var deferred = $q.defer();
                    jobBoardService.getAllJobBoards(function(jobBoards){
                        angular.forEach(jobBoards.resultList, function(jb){
                            if(jb.name === $route.current.params.jbName){
                                deferred.resolve(jobBoardDataSerializeFAC(jb));
                            }
                        });
                    });
                    return deferred.promise;
                }
            }
        });

        $routeProvider.when('/add', {
            templateUrl: 'tracking/addEditJobBoardForm.html',
            controller: 'jobBoardAddCtrl'
        });

        $routeProvider.otherwise({ redirectTo: '/list' });
        $locationProvider.hashPrefix('');
    }])

    // formatting for true/false value in response
    .filter('yesNo', function(){
        return function(str){
            return str === true ? 'Yes' : 'No';
        };
    })

    //for common functionality across forms
    .controller('homeController', ['$scope', '$rootScope', '$timeout',
        function ($scope, $rootScope, $timeout) {
            $rootScope.flags = $rootScope.flags || {};
            $rootScope.flags.loading = true;
            $rootScope.$watch('error', function(newVal){
                if (newVal) {
                    $timeout(function(){
                        $rootScope.error = null;
                    }, 5000);
                }
            });

            $rootScope.$watch('notice', function(newVal){
                if (newVal) {
                    $timeout(function(){
                        $rootScope.notice = null;
                    }, 5000);
                }
            });
        }
    ]);